import type { CategorizationStatus, CategorySource, Transaction } from "@/types/Transaction";

export function isAutoCategorized(tx: Pick<Transaction, "categorySource" | "categorizationStatus">): boolean {
  return tx.categorySource === "ml" || tx.categorizationStatus === "suggested";
}

export function needsCategoryReview(
  tx: Pick<Transaction, "category" | "categorizationStatus" | "invoiceImport">,
): boolean {
  if (tx.invoiceImport?.isStatementPayment) return false;
  const category = tx.category?.trim();
  return tx.categorizationStatus === "needs_review" || category === "Other" || !category;
}

export function categorySourceLabel(
  tx: Pick<Transaction, "categorySource" | "categorizationStatus">,
  t: (key: string) => string,
): string | null {
  if (tx.categorySource === "rule") return t("categorization.learned");
  if (isAutoCategorized(tx)) return t("categorization.auto");
  return null;
}

export function withUserCategory<T extends object>(
  tx: T,
  category: string | undefined,
): T & { category?: string; categorySource: CategorySource; categorizationStatus: CategorizationStatus } {
  if (!category?.trim()) {
    return {
      ...tx,
      category: undefined,
      categorySource: "none",
      categorizationStatus: "needs_review",
    };
  }
  return {
    ...tx,
    category,
    categorySource: "user",
    categorizationStatus: "confirmed",
  };
}
